import { ERequestType, fetchGetHelper } from "../../tools/fetch";

const state = {
	loading: false,
	stats: null,
	currentPage: 1,
};
const limit = 10;

const getters = {
	getLoading: function (state) {
		return state.loading;
	},
	getStats: function (state) {
		const page = state.currentPage;
		const offset = (page - 1) * limit;
		return state.stats ? state.stats.slice(offset, offset + limit) : null;
	},
	getAllStats: function (state) {
		return state.stats;
	},
	getTotalPages: function (state) {
		return Math.ceil(state.stats.length / limit);
	},
	getAvailableColumns: function (state) {
		return {
			permanence: state.stats.reduce((acc, val) => acc + val.permanence, 0) > 0,
			web: state.stats.reduce((acc, val) => acc + val.web, 0) > 0,
			restaurant: state.stats.reduce((acc, val) => acc + val.restaurant, 0) > 0,
			google: state.stats.reduce((acc, val) => acc + val.google, 0) > 0,
			instagram: state.stats.reduce((acc, val) => acc + val.instagram, 0) > 0,
			facebook: state.stats.reduce((acc, val) => acc + val.facebook, 0) > 0,
		};
	},
};

const mutations = {
	setLoading: function (state, payload) {
		state.loading = payload;
	},
	setStats: function (state, payload) {
		state.stats = payload;
	},
	setCurrentPage: function (state, page) {
		state.currentPage = page;
	},
};

const actions = {
	loadStats: function ({ state, rootState, commit, dispatch, getters, rootGetters }, { startDateTs, endDateTs }) {
		return new Promise((resolve, reject) => {
			let userDatas = rootGetters["newUsers/getUser"];
			let uid = rootGetters["newUsers/getUidPublic"];

			if (!userDatas) return reject(new Error("loadStats - Error no user datas mDB"));

			const params = new URLSearchParams();
			params.append("restoid", uid);
			params.append("startDateTs", startDateTs);
			params.append("endDateTs", endDateTs);

			commit("setLoading", true);
			fetchGetHelper(ERequestType.STATS.GET_BY_DATES, params.toString(), userDatas.token)
				.then((res) => {
					commit("setStats", res.data.docs);
					commit("setLoading", false);
					resolve();
				})
				.catch((err) => {
					commit("setLoading", false);
					reject(err);
				});
		});
	},
	setCurrentPage: function ({ commit }, page) {
		commit("setCurrentPage", page);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
